import { createSelector } from '@reduxjs/toolkit';

import {
  selectExchangesList,
  selectExchangesLoading,
  toExchangeOptions,
} from '@skynet/data-shared-exchanges';
import type { ExchangesState } from '@skynet/data-shared-exchanges';

/**
 * Mount-point adapter for the shared exchanges slice as mounted on the MM
 * channel at the root `exchanges` key. Wraps the slice-relative selectors from
 * `@skynet/data-shared-exchanges`.
 */
export interface Store {
  exchanges: ExchangesState;
}

export const selectIsExchangesLoading = (store: Store) => selectExchangesLoading(store.exchanges);

export const selectExchanges = (store: Store) => selectExchangesList(store.exchanges);

// exchange options/suggestions for autocomplete in NewLoanModal form
export const selectExchangeOptions = createSelector(selectExchanges, toExchangeOptions);
